import { GridColDef } from "@mui/x-data-grid";
import { AppTable } from "components/molecules";
import { TableHelper } from "helpers";
import { usePaginationRequest } from "hooks";
import { IGetMaterialRequirementBookedPalletsRequest } from "model";
import { IDeliveryProgress } from "model/LoadingOrder/IDeliveryProgress";
import { useState } from "react";
import { MaterialRequirementApiService } from "services";
import { CURRENT_PAGE_SIZE, FIRST_PAGE } from "utils/Const";
import { I18nTranslator, translations } from "utils/i18n";

interface IProductListProps {
  id: string;
}
const ExportedPalletList = (props: IProductListProps) => {
  const { id } = props;
  const [refresh, setRefresh] = useState(false);

  const [request, setRequest] =
    useState<IGetMaterialRequirementBookedPalletsRequest>({
      requestMaterialId: id,
      pageNumber: FIRST_PAGE,
      pageSize: CURRENT_PAGE_SIZE,
    });

  const { loading, result } = usePaginationRequest<
    IGetMaterialRequirementBookedPalletsRequest,
    any[]
  >(
    request,
    MaterialRequirementApiService.getMaterialRequirementBookedPallets,
    [],
    {
      refresh: refresh,
    },
    () => {
      setRefresh(false);
    }
  );

  const _handleChangePage = (pageNumber: number) => {
    setRequest({
      ...request,
      pageNumber,
    });
  };

  const _handleSearch = (searchText: string) => {
    setRequest({
      ...request,
      searchText,
    });
  };

  const _handlePageSizeChange = (pageSize: number) => {
    setRequest({ ...request, pageSize: pageSize });
  };

  const COLUMNS: GridColDef[] = [
    TableHelper.renderSTT(),
    TableHelper.createCell({
      field: "strStatus",
      headerName: I18nTranslator(translations.receive.status),
      size: "small",
      align: "left",
    }),
    TableHelper.createCell({
      field: "zoneName",
      headerName: I18nTranslator(translations.masterData.zoneName),
      size: "small",
      align: "left",
    }),
    TableHelper.createCell({
      field: "locationName",
      headerName: I18nTranslator(translations.masterData.locationName),
      size: "small",
      align: "left",
    }),
    TableHelper.createCell({
      field: "palletCode",
      headerName: I18nTranslator(translations.receive.palletCode),
      size: "small",
      align: "left",
    }),
    TableHelper.createCell({
      field: "productCode",
      headerName: I18nTranslator(translations.receive.productCode),
      size: "small",
      align: "left",
    }),
    TableHelper.createCell({
      field: "productName",
      headerName: I18nTranslator(translations.receive.productName),
      size: "medium",
      align: "left",
    }),
    TableHelper.createCell({
      field: "productLot",
      headerName: I18nTranslator(translations.receive.productLot),
      size: "small",
      align: "left",
    }),
    TableHelper.createCell({
      field: "strManufacturingDate",
      headerName: I18nTranslator(translations.receive.manufacturingDate),
      size: "small",
      align: "left",
    }),
    TableHelper.createCell({
      field: "strExpiredDate",
      headerName: I18nTranslator(translations.receive.expiryDate),
      size: "small",
      align: "left",
    }),
    TableHelper.createCell({
      field: "palletQuantity",
      headerName: I18nTranslator(translations.receive.quantityOnPallet),
      size: "small",
      align: "right",
    }),
    TableHelper.createCell({
      field: "bookedQty",
      headerName: I18nTranslator(translations.receive.bookedQuantity),
      size: "small",
      align: "right",
    }),
    TableHelper.createCell({
      field: "quantity",
      headerName: I18nTranslator(translations.receive.prepareQuantity),
      size: "small",
      align: "right",
    }),
    TableHelper.createCell({
      field: "note",
      headerName: I18nTranslator(translations.receive.note),
      size: "small",
      align: "left",
      sortable: true,
    }),
  ];
  return (
    <AppTable<IDeliveryProgress>
      loading={loading}
      data={result}
      columns={COLUMNS}
      hideAddNew
      onSearch={_handleSearch}
      searchPlaceholder={I18nTranslator(
        translations.placeholder.searchDeliveryProgress
      )}
      onChangePage={_handleChangePage}
      removeActionColumn
      hideHeader
      defaultHeaderTable={330}
      onPageSizeChange={_handlePageSizeChange}
    />
  );
};

export default ExportedPalletList;
